<div id="layout">
  @if (sideMenuVisible) {
    <div class="sidebar-container d-none d-lg-block">
      <app-side-menu class="d-block"></app-side-menu>
    </div>
  }
  <main>
    <div class="top-bar">
      <div class="container px-0">
        <app-top-bar></app-top-bar>
      </div>
    </div>
    <router-outlet></router-outlet>
  </main>
</div>


